module.exports = __webpack_public_path__ + "img/earth.bb274ad8.svg";